import { storeToRefs } from 'pinia';

import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useUser } from '@/modules/viewer/composables/useUser';

export const useItemShare = () => {
  const { isCurrentItemOwner } = useUser();
  const viewerItemStore = useViewerItemStore();

  const { sharingModeIcon } = storeToRefs(viewerItemStore);

  const getSharingIcon = () => {
    return isCurrentItemOwner.value ? sharingModeIcon.value : 'general.share';
  };
  return {
    getSharingIcon,
  };
};
